import { StyleSheet, ActivityIndicator, ScrollView, Keyboard } from 'react-native'
import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { ThemedView } from '@app/theme'
import CommonHeader from '@app/sharedComponents/Header/Header'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { PrivateStackParamList } from '@app/navigationApp/types'
import { getBanksList } from './services/bankSelectService';
import PopularBanks from './components/PopularBanks';
import AllBanks from './components/AllBanks';
import SearchBank from './components/SearchBank';
import Stepper from '@app/sharedComponents/Stepper/Stepper'
import { useStepperData } from '@app/hooks/useStepperData'
import PageLoader from '@app/sharedComponents/PageLoader/PageLoader'

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'BANK_SELECT'>;


const BankSelect = ({ navigation, route }: ScreenProps) => {


    const [banks, setBanks] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');

    const { stepperData , isLoading : stepperLoading } = useStepperData();


    const onBankSelect = useCallback((bankCode: string, bankName: string) => {
        Keyboard.dismiss();
        navigation.navigate('BANK_ACCOUNT_ADD', { bankCode, bankName });
    }, [navigation]);


    const fetchBanks = async () => {
        setLoading(true);
        try {
            const res = await getBanksList();
            setBanks(res);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchBanks();
    }, []);


    const filteredBanks = useMemo(() => {
        if (searchText.length > 0) {
            return Object.fromEntries(
                Object.entries(banks?.ALLBANKS || {}).filter(([_, value]) => 
                    typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
                )
            );
        }
        return banks?.ALLBANKS || {};
    }, [searchText, banks?.ALLBANKS]);


    if (loading || stepperLoading) {
        return <ThemedView alignItems='center' justifyContent='center' flex={1} bg='bg-surface-primary'>
            <PageLoader />
        </ThemedView>
    }

    return (
        <ThemedView flex={1} bg='bg-surface-primary'>
            <CommonHeader hideBottomBorder label='Select bank' navigation={navigation} pageName={route.name} />
            <Stepper stepperData={stepperData} />
            <ScrollView keyboardShouldPersistTaps="handled">
                <ThemedView padding='lg' paddingTop='2xl'>
                    <SearchBank searchText={searchText} setSearchText={setSearchText} />
                    {(banks?.POPULAR && searchText.length < 1) && <PopularBanks  onBankSelect={onBankSelect} banks={banks?.POPULAR} />}
                    {banks?.ALLBANKS && <AllBanks showTitle={searchText.length < 1} banks={filteredBanks} onBankSelect={onBankSelect} />}
                </ThemedView>
            </ScrollView>
        </ThemedView>
    )
}

export default BankSelect

const styles = StyleSheet.create({})